// extracted by mini-css-extract-plugin
module.exports = {"answer":"Answer_answer__Pmwu_","answer__button":"Answer_answer__button__pdGTq","answer__selectedButton":"Answer_answer__selectedButton___mPpk"};